import React from "react";

const Contact = () => {
    return(
        <div>
 <div class="row ">
      <div class="col-lg-7 container-fluid pd-0">
        <h3 className="cent">Reach out to us anytime and we’ll happily answer your questions. </h3><pre></pre>
          <img class="img" src="/assets/penguin.png" alt="Designer image" />

          <table class="center">
  <tr>
    <th>Mail:</th>
    <th>Perifilter@yanchi.com</th>
    
  </tr>
  <tr>
    <td>Contact:</td>
    <td>+91 1234567890</td>
  
  </tr>
</table>
      </div>
    </div>
        </div>
    );
}
export default Contact;